import SuperQuery from '@themgoncalves/super-query';

import flatten from 'ggApp/utils/flattenObject';
import breakpoints from 'ggApp/shared/components/viewport/breakpoints';
import screens from './screens';

const flattenedBreakpoints = flatten(breakpoints);

const theme = {
    breakpoints,
    superQuery: SuperQuery(flattenedBreakpoints),
    screens,
    colors: {
        grey75: 'rgba(102, 102, 102, 0.75)',
        grey50: '#989898',
        yolk120: '#EDA210',
    },
};

export default theme;
